import React, {useState,useEffect} from 'react'
import _ from 'lodash';
import Chart from "react-apexcharts";
import BSCard from '../components/BS-Card';
import PageHeader from '../components/PageHeader';
import apiService from '../services/api';

function Dashboard(props){
    var date = new Date();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    
    useEffect(()=>{
        async function fetchData(){
            try {
                setLoading(true);
                // Lấy ratings tháng hiện tại từ API
                const response = await apiService.getCurrentMonthRatings();
                setData(response.data);

                // Lấy thông tin user hiện tại từ sessionStorage
                const userInfo = sessionStorage.getItem('user');
                if(userInfo) {
                    setCurrentUser(JSON.parse(userInfo));
                }
            } catch (err) {
                console.error('Error fetching data:', err);
                setError('Lỗi khi tải dữ liệu');
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    },[]);

    // Kiểm tra quyền admin
    const isAdmin = currentUser && (currentUser.permission === 'admin' || currentUser['permission '] === 'admin');

    // Loại bỏ function handleLogout vì đã có trong PageHeader

    function countRating(data){
        var staffMap = new Map();
        
        for(var dt of data){
            var tot = 0, kha = 0;
            
            // Rating đã là string, không cần chuyển đổi
            const ratingText = dt.rating || '';
            
            const createDate = new Date(dt.createAt);
            if(createDate.getMonth() === date.getMonth()){
                if(ratingText === "Tốt") tot++;
                if(ratingText === "Khá") kha++;
                
                const staffKey = dt.staffId || dt.displayName;
                const staffName = dt.displayName || dt.staffName || dt.staffId;
                
                if(!staffMap.has(staffKey)){
                    staffMap.set(staffKey, {
                        tot: tot,
                        kha: kha,
                        staff: staffName,
                        tong: tot + kha
                    });
                } else {
                    const existing = staffMap.get(staffKey);
                    existing.kha += kha;
                    existing.tot += tot;
                    existing.tong = existing.tot + existing.kha;
                }
            }
        }
        
        var rate = Array.from(staffMap.values());
        rate.sort((a,b) => b.tong - a.tong);
        rate = rate.slice(0, 5);
        return rate;
    }

    var rate = countRating(data);
    var staff = [], tot = [], kha = [];
    for(var r of rate){
        staff.push(r.staff);
        tot.push(r.tot);
        kha.push(r.kha);
    }

    var options = {
        chart: {
            id: "top5Chart",
            type: "bar",
            stacked: true
        },
        xaxis: {
            categories: staff
        }
    };

    var series = [{
        name: 'Số lượt đánh giá Tốt',
        data: tot
    },{
        name: 'Số lượt đánh giá Khá',
        data: kha
    }];

    var tot2 = 0, kha2 = 0, binhthuong2 = 0, kem2 = 0;
    for(var d of data){
        const createDate = new Date(d.createAt);
        if(createDate.getMonth() === date.getMonth()){
            // Rating đã là string, không cần chuyển đổi
            const ratingText = d.rating || '';
            
            // eslint-disable-next-line default-case
            switch(ratingText){
                case "Tốt": tot2++; break;
                case "Khá": kha2++; break;
                case "Bình thường": binhthuong2++; break;
                case "Chưa tốt": kem2++; break;
            }
        }
    }

    var option2 = {
        labels: ["Tốt", "Khá", "Bình thường", "Chưa tốt"],
        plotOptions: {
            pie: {
              donut: {
                labels: {
                    show: true,
                    total: {
                        show: true,
                        label: 'Tổng lượt đánh giá',
                        fontWeight: 600,
                        fontSize: "20px",
                        color: '#373d3f',
                        formatter: function (w) {
                            return w.globals.seriesTotals.reduce((a, b) => {
                                return a + b
                            }, 0)
                        }
                    }
                }
              }
            }
        }
    }

    var series2 = [tot2, kha2, binhthuong2, kem2];

    if (loading) {
        return (
            <div className="main">
                <div className="d-flex justify-content-center align-items-center" style={{height: "400px"}}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Đang tải dữ liệu...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="main">
                <div className="d-flex justify-content-center align-items-center" style={{height: "400px"}}>
                    <div className="text-center">
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                        <button 
                            className="btn btn-primary" 
                            onClick={() => window.location.reload()}
                        >
                            Thử lại
                        </button>
                    </div>
                </div>
            </div>
        );
    }
        
    return(
        <>
            <div className="main">
                <PageHeader 
                    title="Dashboard - Trang chủ quản trị" 
                    subtitle="Thống kê và quản lý hệ thống đánh giá"
                />
                <div className="row m-0 p-3">
                    <BSCard href="/users" color="#4e73df" title="Nhân viên" statusText="Quản lý nhân viên" icon={<i className="bi bi-person-fill fs-1" style={{color: "#dddfeb"}}></i>}/>
                    <BSCard href="/history" color="#1cc88a" title="Lịch sử" statusText="Lịch sử đánh giá" icon={<i className="bi bi-clock-fill fs-1" style={{color: "#dddfeb"}}></i>}/>
                    {isAdmin && (
                        <BSCard href="/login-users" color="#e74a3b" title="Quản lý Admin" statusText="Tài khoản admin" icon={<i className="bi bi-shield-lock-fill fs-1" style={{color: "#dddfeb"}}></i>}/>
                    )}
                </div>
                <div className="row m-0 p-3">
                    <div className="col-xl-6">
                        <div className="p-3 shadow rounded">
                            <h3 className="text-center pt-2 pb-2">TOP 5 NHÂN VIÊN CÓ ĐÁNH GIÁ CAO TRONG THÁNG</h3>
                            <div style={{height: "550px"}}>
                                {(_.isEmpty(data))?
                                <div className=" h-100 d-flex justify-content-center">
                                    <div className="align-self-center">Không có dữ liệu</div>
                                </div>:
                                <Chart options={options} series={series} type="bar"/>}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="p-3 shadow rounded">
                            <h3 className="text-center pt-2 pb-2">TỔNG SỐ LƯỢT ĐÁNH GIÁ TRONG THÁNG</h3>
                            <div className="donut" style={{height: "550px"}}>
                                {(_.isEmpty(data))?
                                <div className=" h-100 d-flex justify-content-center">
                                    <div className="align-self-center">Không có dữ liệu</div>
                                </div>:
                                <Chart height="520" options={option2} series={series2} type="donut"/>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Dashboard;